export default "__VITE_ASSET__921fe5c5__"